import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface ProjectSearchParams {
  keyword?: string;
  
  projectReferenceId?: string;
  source?: string;
  projectType?: string;
  constructionPhase?: string;
  city?: string;
  state?: string;
  country?: string;
  latitude?: string;
  longitude?: string;
  salesProjectId?: string;
  startDate?: string;
  endDate?: string;
  startDateS?: string;
  endDateS?: string;
  startDateE?: string;
  endDateE?: string;
  valueEstimation?: string;
  valueMin?: string;
  valueMax?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getProjects = async (params: ProjectSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/projects/search_sales_projects", {
    params,
  });
  return response.data;
};

// Load project options from bidding view endpoint
export const getAllProjects = async () => {
  const response = await axiosInstance.get("/sales/projects/view_sales_projects");
  return response.data;
};

// Function to get project details by ID
export const getProjectById = async (projectId: string) => {
  const response = await axiosInstance.get(`/sales/projects/view_sales_project/${encodeURIComponent(projectId)}`);
  return response.data;
};

export interface ProjectLocationSearchParams {
  keyword?: string;
  projectId?: string;
  locationId?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getProjectLocations = async (params: ProjectLocationSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/projects/search_sales_projects", {
    params,
  });
  return response.data;
};


export const fetchProjectPhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/sales/projects/image/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Project
export const createProject = async (data) => {
  const formData = {
    projectName: data.projectName,
    projectAddress: data.projectAddress,
    region: data.region,
    projectType: data.projectType,
    projectEmail: data.projectEmail,
    managerName: data.managerName,
    contactNumber:data.contactNumber,
  };

  const response = await axiosInstance.post(`/sales/projects/create_sales_project`, data);
  return response.data; // contains the project `id` or `code`
};


// Step 2: Upload Photo by Project ID
export const uploadProjectPhoto = async (projectId, file) => {
  const formData = new FormData();
  formData.append("image", file);

  return axiosInstance.post(`/sales/projects/upload-image/${projectId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Project
export const editProject = async (data) => {
  const formData = {
    projectName: data.projectName,
    projectAddress: data.projectAddress,
    region: data.region,
    projectType: data.projectType,
    projectEmail: data.projectEmail,
    managerName: data.managerName,
    contactNumber: data.contactNumber,
  };

  const response = await axiosInstance.put(`/sales/projects/update_sales_project/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteProject = async (projectId: string) => {
  const response = await axiosInstance.delete(`/sales/projects/delete_sales_project/${projectId}`);
  return response.data;
};
